export default __webpack_public_path__ + "static/media/partnership.500d1a15.png";